import {FITH2Symbol, FITH2SymbolStates, ISymbolData} from "../symbols/FITH2Symbol";
import {FireInTheHole2} from "../FireInTheHole2";
import {gsap} from "gsap";
import {FITH2SoundManager} from "../sound/FITH2SoundManager";
import {APISetting} from "@nolimitcity/slot-launcher/bin/interfaces/APISettingsSystem";
import {ArrayHelper} from "@nolimitcity/slot-game/bin/utils/ArrayHelper";
import {FITH2Helper} from "../utils/FITH2Helper";
import {ScatterCounter} from "../view/ScatterCounter";
import {FITH2Scatter} from "../symbols/FITH2Scatter";
import {FITH2GameConfig} from "../configs/FITH2GameConfig";
import {FITH2Dirt} from "../symbols/FITH2Dirt";
import {FITH2Wild} from "../symbols/FITH2Wild";
import {FITH2Split} from "../symbols/FITH2Split";
import {Logger} from "@nolimitcity/slot-launcher/bin/utils/Logger";

export class FITH2ReelView extends PIXI.Container {
    private readonly DURATION_SYMBOLS_FALL_OUT: number = 0.5;
    private readonly DURATION_SYMBOLS_FALL_IN: number = 0.2;
    private readonly DURATION_SYMBOLS_FALL: number = 0.3;
    private readonly DURATION_SYMBOLS_COLLAPSE_FALL: number = 0.05;
    private readonly DURATION_SYMBOLS_UNBLUR: number = 0.02;

    private readonly DURATION_FAST_SYMBOLS_FALL_IN: number = 0;
    private readonly DURATION_FAST_SYMBOLS_FALL_OUT: number = 0.4;
    //DURATION_FAST_SYMBOLS_COLLAPSE_FALL cant be 0
    private readonly DURATION_FAST_SYMBOLS_COLLAPSE_FALL: number = 0.05;

    private readonly SYMBOLS_FALL_IN_DELAY: number = 0.05;
    private readonly SYMBOLS_FALL_OUT_DELAY: number = 0.03;
    private readonly START_DROP_IN_POSITION: number = -700;

    private _dirtSymbolView: PIXI.Container;
    private _fullWildSymbolWinView: PIXI.Container;
    private _scatterSymbolView: PIXI.Container;
    private _initialWinSymbolView: PIXI.Container;
    private _scatterWinView: PIXI.Container;
    private _allOutSymbols: FITH2Symbol[] = [];
    private _collapsedReel: FITH2Symbol[] = [];
    private _isStacked: boolean = false;

    private readonly _reelId: number;

    constructor(id: number) {
        super();
        this._scatterWinView = new PIXI.Container();
        this._scatterSymbolView = new PIXI.Container();
        this._dirtSymbolView = new PIXI.Container();
        this._fullWildSymbolWinView = new PIXI.Container();
        this._initialWinSymbolView = new PIXI.Container();

        this._scatterWinView.name = "scatterWinView" + id;
        this._scatterSymbolView.name = "scatterSymbol" + id;
        this._dirtSymbolView.name = "dirt" + id;
        this._fullWildSymbolWinView.name = "fullWildWin" + id;
        this._initialWinSymbolView.name = "initialWinSymbol" + id;

        this.name = "Reel " + id;
        this._isStacked = false;
        this._reelId = id;

        this.position = FITH2GameConfig.reelPositions[id];
        this._scatterSymbolView.position = FITH2GameConfig.reelPositions[id];
        this._dirtSymbolView.position = FITH2GameConfig.reelPositions[id];
        this._fullWildSymbolWinView.position = FITH2GameConfig.reelPositions[id];
        this._scatterWinView.position = FITH2GameConfig.reelPositions[id];
        this._initialWinSymbolView.position = FITH2GameConfig.reelPositions[id];
        this._scatterSymbolView.sortableChildren = true;

        const mainReelsMask: PIXI.Graphics = new PIXI.Graphics();
        mainReelsMask.name = "scatterSymbolViewMask";
        mainReelsMask.beginFill(0xFFFF0B, 1);
        mainReelsMask.drawRect(-1*FITH2GameConfig.symbolWidth, -0.5*FITH2GameConfig.symbolHeight, (FITH2GameConfig.symbolWidth * 2), FITH2GameConfig.symbolHeight * 6);

        this._scatterSymbolView.addChild(mainReelsMask);
        this._scatterSymbolView.mask = mainReelsMask;
    }

    public removeAvalancheSymbol(symbol: FITH2Symbol) {
        if (symbol.symName === "S") {
            this.scatterSymbolView.removeChild(symbol);
        } else {
            this.removeChild(symbol);
        }
        symbol.remove();
    }

    public initReel(reelData: ISymbolData[]): void {
        const barId: number = FireInTheHole2.model.barId;
        if (FireInTheHole2.model.isRestore) {
            let symbolCount: number = 0,
                topId: number = (6 - reelData.length);
            reelData.forEach((symData: ISymbolData, i: number) => {
                const symbol: FITH2Symbol = this.createSymbol(symData, FITH2SymbolStates.NORMAL, symData.id > barId);
                symbol.position.set(0, (topId + symbolCount) * FITH2GameConfig.symbolHeight);

                if (FireInTheHole2.model.isRestore && symbol.symName[0] === "S" && !symbol.isBehindDirt && !symbol.isBehindBar) {
                    ScatterCounter.allScatters.push(<FITH2Scatter>symbol);
                }
                this._allOutSymbols.push(symbol);
                symbolCount++;
            });
        } else {
            reelData.forEach((symData: ISymbolData, i: number) => {
                const symbol: FITH2Symbol = this.createSymbol(symData, FITH2SymbolStates.NORMAL, i >= barId);
                symbol.position.set(0, FITH2GameConfig.symbolHeight * i);
                this._allOutSymbols.push(symbol);
            });
        }
    }

    public createSymbol(symbolData: ISymbolData, state: FITH2SymbolStates, behindBar: boolean): FITH2Symbol {
        let symbol: FITH2Symbol;

        if (symbolData.symName === "S" || symbolData.symName === "DS") {
            symbol = new FITH2Scatter(symbolData, state);
        } else if (symbolData.symName === "W" || symbolData.symName === "DW") {
            symbol = new FITH2Wild(symbolData, state);
        } else if (symbolData.symName === "X" || symbolData.symName === "DX") {
            symbol = new FITH2Split(symbolData, state);
        } else if (symbolData.symName === "D") {
            symbol = new FITH2Dirt(symbolData, state);
        } else {
            symbol = new FITH2Symbol(symbolData, state);
        }
        if (symbol.symName === "D" || symbol.isBehindDirt || behindBar) {
            this._dirtSymbolView.addChild(symbol);
        } else if (FITH2Helper.isLargerSymbol(symbol.symName)) {
            this._scatterSymbolView.addChild(symbol);
        } else {
            this.addChild(symbol);
        }
        symbol.isBehindBar = behindBar;
        return symbol;
    }

    public dropOut(reelDelay: number): gsap.core.Timeline {
        const tl = gsap.timeline({delay: reelDelay}),
            fastSpin: boolean = this.isFastSpin,
            subTimelines: gsap.core.Timeline[] = [];
        let counter: number = 0;
        while (this._allOutSymbols.length > 0) {
            const symbol: FITH2Symbol = this._allOutSymbols.pop()!;
            FITH2Helper.checkIfSymbolIsNull(symbol);
            const fromY: number = symbol.position.y,
                symSpinStopDelay: number = (fastSpin ? 0 : this.SYMBOLS_FALL_OUT_DELAY) * counter,
                turnToBlurDelay: number = (fastSpin ? 0 : this.SYMBOLS_FALL_OUT_DELAY) * counter,
                timeline = gsap.timeline({delay: symSpinStopDelay});

            timeline.add([
                () => {
                    if (FITH2Helper.isLargerSymbol(symbol.symName)) {
                        symbol.parent.removeChild(symbol);
                        this.addChild(symbol);
                    }
                },
                gsap.to(symbol.position, {
                    duration: this.DURATION_SYMBOLS_FALL_OUT,
                    y: fromY * 2 - this.START_DROP_IN_POSITION,
                    ease: "sine.in"
                })
            ]);
            timeline.add([
                symbol.getStateAnimation(FITH2SymbolStates.BLUR, this.DURATION_SYMBOLS_UNBLUR)
            ], turnToBlurDelay);
            if (symbol.symName === "W") {
                Logger.logDev("dropout, isBlur 111")
            }
            timeline.add(() => this.removeAvalancheSymbol(symbol));
            subTimelines.push(timeline);
            counter++;
        }


        if (subTimelines.length > 0) {
            subTimelines.push(gsap.timeline().add(() => {
                let scatterSymbolIndex: number = 0;
                this._allOutSymbols.forEach((sym: FITH2Symbol, i: number) => {
                    if (sym.symName === "S") {
                        sym.parent.removeChild(sym);
                        this.scatterSymbolView.addChildAt(sym, scatterSymbolIndex++);
                    }
                });
            }));
        }
        if (this._reelId === 0) {
            tl.add(() => FITH2SoundManager.playReelOut());
        }

        tl.add(subTimelines);
        return tl;
    }

    private symbolBounce(symbol: FITH2Symbol, toY: number, newSymbol: boolean = true): gsap.core.Timeline {
        const tl = gsap.timeline();
        if (newSymbol) {
            if (!(symbol.isBehindDirt || symbol.isBehindBar)) {
                if (symbol.symName === "S") {
                    (<FITH2Scatter>symbol).isAdded = true;
                    tl.add(ScatterCounter.addScatter(<FITH2Scatter>symbol));
                } else {
                    tl.add(symbol.getStateAnimation(FITH2SymbolStates.LANDING));
                }
            }
        }
        const bounceDuration: number = 0.02 + symbol.id * 0.005;

        tl.add([
            () => {
                if (FITH2Helper.isLargerSymbol(symbol.symName) && !(symbol.isBehindDirt || symbol.isBehindBar)) {
                    symbol.parent.removeChild(symbol);
                    this._scatterWinView.addChild(symbol);
                }
            },
            gsap.to(symbol.position, bounceDuration, {
                y: toY - 5,
                ease: "power3.in"
            })], 0);
        tl.add(gsap.to(symbol.position, 0.03 + symbol.id * 0.005, {
            y: toY,
            ease: "power3.out"
        }), bounceDuration);

        return tl;
    }

    private firstSymbolLandingOnReel(): void {
        if (FireInTheHole2.model.nearWinReels[this._reelId]) {
            FireInTheHole2.gameViewContainer.onNearWin();
            FITH2SoundManager.playAnticipationLandingSound(this._reelId);
        } else {
            FITH2SoundManager.playLandingSound(this._reelId);
        }
        FireInTheHole2.reelAnticipation.fadeOut(this._reelId);
    }

    public dropIn(reelDelay: number, hasAnticipation: boolean): gsap.core.Timeline {
        const fastSpin: boolean = this.isFastSpin,
            tl = gsap.timeline(),
            reelData: string[] = FireInTheHole2.model.reels[this._reelId];
        let isFirstSymbol: boolean = true;
        const subTimelines: gsap.core.Timeline[] = [];
        this._allOutSymbols = [];
        this._isStacked = false;


        reelData.forEach((symData: string, i: number) => {
            const symbol: FITH2Symbol = this.createSymbol({
                    symName: symData,
                    reelSize: 6,
                    symSize: 1,
                    id: i,
                    reelId: this._reelId
                }, reelDelay > 0 ? FITH2SymbolStates.BLUR : FITH2SymbolStates.NORMAL, i > 2),
                isFlyingUp: boolean = ((i > 2) || symData[0] == "D");
            this._allOutSymbols.push(symbol);
            const fallDuration: number = fastSpin ? this.DURATION_FAST_SYMBOLS_FALL_IN : this.DURATION_SYMBOLS_FALL_IN;
            symbol.position.y = this.START_DROP_IN_POSITION * (isFlyingUp ? -1 : 1) + i * FITH2GameConfig.symbolHeight;
            FITH2Helper.checkIfSymbolIsNull(symbol);
            if (symData[0] === "D" || i > 2) {
                tl.add([
                    gsap.to(symbol.position, {
                        duration: fallDuration,
                        y: FITH2GameConfig.symbolHeight * i,
                        ease: "power1.in",
                        delay: (fastSpin || FireInTheHole2.model.nearWinReels[this._reelId]) ? 0 : this.SYMBOLS_FALL_IN_DELAY
                    })
                ], 0);
                tl.add(this.symbolBounce(symbol, FITH2GameConfig.symbolHeight * i), fallDuration + this.SYMBOLS_FALL_IN_DELAY);
            } else {
                //stop spin fast if feature buy
                const timeline = gsap.timeline({delay: ((fastSpin || FireInTheHole2.model.nearWinReels[this._reelId]) ? 0 : (this.SYMBOLS_FALL_IN_DELAY * (6 - i)))});
                const delay: number = this.SYMBOLS_FALL_IN_DELAY;

                timeline.add(gsap.to(symbol.position, {
                    duration: fallDuration,
                    y: FITH2GameConfig.symbolHeight * i,
                    ease: "power1.in",
                    delay: delay
                }));
                timeline.add([
                    this.symbolBounce(symbol, FITH2GameConfig.symbolHeight * i),
                    () => {
                    if (isFirstSymbol) {
                        this.firstSymbolLandingOnReel();
                        isFirstSymbol = false;
                    }
                }], delay+fallDuration);
                subTimelines.push(timeline);
            }
        });
        if (this._reelId === 0) {
            tl.add(() => FITH2SoundManager.playReelIn(), reelDelay);
        }
        tl.add(subTimelines, fastSpin ? 0 : reelDelay);
        if (hasAnticipation) {
            tl.add(() => FireInTheHole2.reelAnticipation.update(this._reelId + 1));
        }
        return tl;
    }

    public fillUp(reelDelay: number, hasAnticipation: boolean): gsap.core.Timeline {
        const temp: FITH2Symbol[] = [];

        this._allOutSymbols.forEach((sym: FITH2Symbol) => {
            temp.push(sym);
        });
        this._allOutSymbols = [];
        const fastSpin: boolean = this.isFastSpin,
            fillUpTimeline = gsap.timeline({delay: fastSpin ? 0 : reelDelay}),
            subTimelines: gsap.core.Timeline[] = [],
            reelsFillUpData: ISymbolData[] = FireInTheHole2.model.reelsFillUpData[this._reelId],
            startIndex: number = (6 - temp.length - 1);

        let timeline: gsap.core.Timeline,
            isFirstSymbol: boolean = true;

        for (let i: number = startIndex; i > -1; i--) {
            const symbol: FITH2Symbol = this.createSymbol(reelsFillUpData[i], (reelDelay<=0 || fastSpin) ? FITH2SymbolStates.NORMAL : FITH2SymbolStates.BLUR, false);
            FITH2Helper.checkIfSymbolIsNull(symbol);
            symbol.position.y = this.START_DROP_IN_POSITION + i * FITH2GameConfig.symbolHeight;
            temp.unshift(symbol);
            timeline = gsap.timeline({delay: ((fastSpin || FireInTheHole2.model.nearWinReels[this._reelId]) ? 0 : (this.SYMBOLS_FALL_IN_DELAY * (startIndex - i)))});
            let delay: number = this.SYMBOLS_FALL_IN_DELAY;
            const fallDuration: number = fastSpin ? this.DURATION_FAST_SYMBOLS_FALL_IN : this.DURATION_SYMBOLS_FALL_IN;
            timeline.add([
                gsap.to(symbol.position, {
                    duration: fallDuration,
                    y: FITH2GameConfig.symbolHeight * i,
                    ease: "power1.in",
                    delay: delay
                })
            ]);
            timeline.add([
                this.symbolBounce(symbol, FITH2GameConfig.symbolHeight * i),
                () => {
                if (isFirstSymbol) {
                    this.firstSymbolLandingOnReel();
                    isFirstSymbol = false;
                }
            }], delay+fallDuration);
            subTimelines.push(timeline);
        }

        this._allOutSymbols = temp;
        fillUpTimeline.add(subTimelines);
        if (hasAnticipation) {
            fillUpTimeline.add(() => FireInTheHole2.reelAnticipation.update(this._reelId + 1));
        }
        return fillUpTimeline;
    }

    public calculateCollapseData(): void {
        const symbolsLeft: FITH2Symbol[] = ArrayHelper.initArrayWithValues(this._allOutSymbols.length, (j: number) => {
            return this._allOutSymbols[j];
        });
        const underTheBarSymNr: number = Math.min(5, FireInTheHole2.reelTopBar.barId);
        this._collapsedReel = [];
        for (let j: number = 5; j > underTheBarSymNr; j--) {
            this._collapsedReel.push(symbolsLeft[j]);
        }
        for (let i: number = underTheBarSymNr; i >= 0; i--) {
            if (!symbolsLeft[i].isRemoved && !FITH2Helper.isInvisibleSym(symbolsLeft[i].symName)) {
                this._collapsedReel.push(symbolsLeft[i]);
            }
        }

        const temp: string[] = [];
        this._collapsedReel.forEach((sym: FITH2Symbol) => {
            temp.push(sym.symName);
        });
    }

    public collapse(reelDelay: number, barId: number): gsap.core.Timeline {
        const fastSpin: boolean = this.isFastSpin;
        const collapseTimeline: gsap.core.Timeline = gsap.timeline({delay: fastSpin ? 0 : reelDelay}),
            symNum: number = this._collapsedReel.length,
            subTimelines: gsap.core.Timeline[] = [];
        let timeline: gsap.core.Timeline,
            isFirstSymbol: boolean = true,
            toId: number = 6;
        this._allOutSymbols = [];
        for (let i: number = 0; i < symNum; i++) {
            const symbol: FITH2Symbol = this._collapsedReel[i];
            FITH2Helper.checkIfSymbolIsNull(symbol);
            toId--;
            const toY: number = toId * FITH2GameConfig.symbolHeight;
            this._allOutSymbols.push(symbol);
            const duration: number = (toY === symbol.position.y) ? 0 : ((fastSpin ? this.DURATION_FAST_SYMBOLS_COLLAPSE_FALL : this.DURATION_SYMBOLS_COLLAPSE_FALL) * (i + 1));
            timeline = gsap.timeline();
            if (duration > 0) {
                timeline.add([
                    gsap.to(symbol.position, {
                        duration: duration,
                        y: toY,
                        ease: "power2.in"
                    })
                ]);

                timeline.add([
                    () => {
                        if (isFirstSymbol) {
                            FITH2SoundManager.playLandingSound(this._reelId);
                            isFirstSymbol = false;
                        }
                    },
                    this.symbolBounce(symbol, toY, false)
                ]);
                symbol.id = toId;
            }
            subTimelines.push(timeline);
        }

        collapseTimeline.add(subTimelines);

        this._allOutSymbols.reverse();
        return collapseTimeline;
    }

    public updateNewSymbolBehindBar(): void {
        const barId: number = FireInTheHole2.model.barId;
        if (barId < 6) {
            this._allOutSymbols[barId].isBehindBar = false;
            if (this._allOutSymbols[barId].symName[0] === "D"){
                this._allOutSymbols[barId].addFrames(false, true);
            }
            if (this._allOutSymbols[barId].symName === "S" && !this._allOutSymbols[barId].isBehindDirt) {
                (<FITH2Scatter>this._allOutSymbols[barId]).isAdded = true;
                ScatterCounter.addScatter(<FITH2Scatter>this._allOutSymbols[barId])
            }
        }
    }

    public turnWild(id: number): gsap.core.Timeline {
        const tl = gsap.timeline();
        const symbol: FITH2Symbol = this.createSymbol({
                id: id,
                reelId: this._reelId,
                symName: "W",
                reelSize: 6,
                symSize: 1
            }, FITH2SymbolStates.NORMAL, false),
            oldSymbol = this._allOutSymbols[id];
        FITH2Helper.checkIfSymbolIsNull(symbol);
        symbol.alpha = 0;
        symbol.position.y = symbol.id * FITH2GameConfig.symbolHeight;
        tl.add([
            gsap.to(symbol, 0.15, {alpha: 1}),
            gsap.to(oldSymbol, 0.15, {alpha: 0}),
            () => {
                this.addChild(symbol);
                this._allOutSymbols.splice(id, 1, symbol);
                oldSymbol.remove();
            }]);
        tl.add((<FITH2Wild>symbol).playWildMining());
        return tl;

    }

    public switch(position: number, newSym: string): gsap.core.Timeline {
        const newSymbol: FITH2Symbol = this.createSymbol({
                symName: newSym,
                reelSize: 6,
                symSize: 1,
                id: position,
                reelId: this._reelId
            }, FITH2SymbolStates.NORMAL, false),
            oldSym: FITH2Symbol = this._allOutSymbols[position];
        newSymbol.alpha = 0;
        newSymbol.position.y = position * FITH2GameConfig.symbolHeight;
        const tl = gsap.timeline();
        if (oldSym.symName === "X") {
            tl.add([
                (<FITH2Split>oldSym).disappear()
            ], 0);
        }
        tl.add(gsap.to(newSymbol, 0.15, {alpha: 1}), 0);
        tl.add(() => {
            this._allOutSymbols.splice(position, 1, newSymbol);
            oldSym.remove();
        });
        return tl;
    }

    public getSymbol(position: number): FITH2Symbol {
        if (position > (this._allOutSymbols.length - 1)) {
            debugger;
        }
        return this._allOutSymbols[position];
    }

    public getAllSymbols(): FITH2Symbol[] {
        return this._allOutSymbols;
    }

    get scatterSymbolView(): PIXI.Container {
        return this._scatterSymbolView;
    }

    get dirtSymbolView(): PIXI.Container {
        return this._dirtSymbolView;
    }

    get initialWinSymbolView(): PIXI.Container {
        return this._initialWinSymbolView;
    }

    get scatterWinView(): PIXI.Container {
        return this._scatterWinView;
    }

    get fullWildSymbolWinView(): PIXI.Container {
        return this._fullWildSymbolWinView;
    }

    get isFastSpin(): boolean {
        const fastSpin: boolean = FireInTheHole2.apiPlugin.settings.get(APISetting.FAST_SPIN, false);
        return fastSpin;
    }

    get needFillUp(): boolean {
        return (this._allOutSymbols.length < 6);
    }

    get needCollapse(): boolean {
        return (this._collapsedReel.length != this._allOutSymbols.length);
    }
}